module.exports = {"available":"Ledigt","booked":"Booket","occupied":"Belagt","booked-occupied":"Booket / Belagt","used":"brugt","until":"til","all-day":"hele dagen","page_over_total":"side {page} af {total}","room-name":"Rum navn","current-booking":"Igangværende","next-booking":"Næste","unknown":"Ukendt","floors":"Etage","today":"i dag","no_bookings":"Ingen møder er booket i dag","no_information":"Ingen information tilgængelig","description":"Beskrivelse","capacity":"Kapacitet","allocated":"Tildelt","booked-occupied-allocated":"Booket / Belagt/ Tildelt"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/da.json
// module id = +RVn
// module chunks = 2